import React, { FC, useState, useLayoutEffect, useRef, MouseEvent } from 'react';
import { Button, ButtonProps } from '@code/innovance-react-ui-kit';

const AsyncButton: FC<ButtonProps> = ({ onClick, disabled, ...otherProps }) => {
  const [isPending, setIsPending] = useState<boolean>(false);
  const mountRef = useRef<boolean>();

  useLayoutEffect(() => {
    mountRef.current = true;

    return () => {
      mountRef.current = false;
    };
  }, []);

  const handleOnClick = (event: MouseEvent<HTMLButtonElement>): void => {
    if (onClick) {
      const promise = (onClick(event) as unknown) as Promise<void>;
      if (!promise) {
        return;
      }
      setIsPending(true);
      promise
        .then(() => {
          if (mountRef.current) {
            setIsPending(false);
          }
        })
        .catch(() => {
          if (mountRef.current) {
            setIsPending(false);
          }
        });
    }
  };
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Button {...otherProps} disabled={isPending || disabled} onClick={handleOnClick} />;
};

export default AsyncButton;
